import { RouterChild } from '@/router';

export default [
  { name: 'term-list', path: 'terms', component: () => import('./views/List.vue') } as RouterChild
];
